// Nombre ESTABLE de la cookie de sesión: NO depende de la versión del build,
// así la sesión sobrevive a cada deploy. La limpieza solo ocurre si el build
// se generó con "npm run deploy force" (VUE_APP_FORCE_CLEAN_SESSION=1).
const _TOKEN_COOKIE = 'kuntev5_token'

// Solo para mostrar la versión en el footer / login
const _VersionAPP = `V${process.env.VUE_APP_VERSION || '10.19'}`

export function getToken() {
    const token = window.$cookies.get(_TOKEN_COOKIE)
    if (token) {
        return token
    }

    // Migración única: antes la cookie se llamaba V<hash-git> y cambiaba en cada
    // deploy. Si existe una cookie vieja con ese formato, la migramos al nombre
    // estable y la eliminamos, para que la sesión sobreviva también al PRIMER
    // deploy de este cambio.
    const legacyKey = window.$cookies.keys().find((key) => /^V[0-9a-f]{4}$/i.test(key))
    if (legacyKey) {
        const legacyToken = window.$cookies.get(legacyKey)
        if (legacyToken) {
            window.$cookies.set(_TOKEN_COOKIE, legacyToken, 60 * 60 * 12)
            window.$cookies.remove(legacyKey)
            return legacyToken
        }
    }

    return null
}

export function setToken(token) {
    return window.$cookies.set(_TOKEN_COOKIE, token, 60 * 60 * 12)
}

export function removeToken() {
    localStorage.clear()
    return window.$cookies.keys().forEach((cookie) => window.$cookies.remove(cookie))
}
export const VersionAPP = _VersionAPP
export const TokenCookie = _TOKEN_COOKIE
export function timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}